import type { Action } from './actions'
import endpoints from 'shared/store/endpoints'
import type { CustomPageItemsShortDTO } from 'shared/types/api'

export type State = {
    content: ?string,
    dataLoaded: ?boolean,
    error?: any,
    networkError?: any,
    menuItems: ?CustomPageItemsShortDTO
}

const initialState: State = {
    content: null,
    dataLoaded: false,
    menuItems: null
}

export const reducer = (state: State = initialState, action: Action): State => {
    switch (action.type) {
        case 'PAGE_DATA_CUSTOM_RESPONSE':
            return {
                ...state,
                ...action.data,
                dataLoaded: true,
                error: undefined,
                networkError: undefined
            }
        case 'PAGE_MENU_ITEMS_CUSTOM_RESPONSE':
            return {
                ...state,
                menuItems: action.data.customPageItemShortDTOS,
                dataLoaded: true,
                networkError: undefined
            }
        case 'PAGE_API_ERROR':
            if (action.page && action.page.startsWith(endpoints.pages.custom)) {
                return {
                    ...state,
                    error: action.error
                }
            } else {
                return state
            }
        case 'RESET_NETWORK_ERROR':
            return {
                ...state,
                networkError: undefined
            }
        case 'PAGE_NETWORK_ERROR':
            return {
                ...state,
                networkError: action.networkError,
                error: undefined
            }
        default:
            return state
    }
}
